// eslint-disable-next-line
import React, { useState } from 'react';

import asesor_icon from 'assets/images/asesor_icon.svg';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PeopleIcon from '@material-ui/icons/People';
import dictionary from 'utils/dictionary';
import { Entity } from 'core/entities';
import { User } from 'core/auth';
import { Employee } from 'core/employee/employee.model';
import { AuthStateAgentInfo } from 'store/modules/auth';

type Props = {
  changeEntity: (event?) => void;
  showSelectEntityMenu?: boolean;
  selectedEntity?: Entity | null | undefined;
  user?: User;
  agentInfo?: AuthStateAgentInfo;
  employeeInformation?: Employee | undefined;
  currentTab?: number;
};

const HeaderMenu: React.FC<Props> = ({
  changeEntity,
  showSelectEntityMenu,
  selectedEntity,
  user,
  agentInfo,
  employeeInformation,
  currentTab,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleEntityChanged = (e) => {
    setAnchorEl(null);
    changeEntity(e);
  };

  return (
    <div>
      <IconButton
        data-testid="profile-menu"
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        color="inherit"
        onClick={handleClick}
      >
        <img src={asesor_icon} alt="asesor" />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            marginTop: 50,
          },
        }}
      >
        {selectedEntity && (
          <MenuItem autoFocus={false}>
            {dictionary.header_entity_label}
            {selectedEntity.commercialName}
          </MenuItem>
        )}

        {currentTab === 2 ? (
          <MenuItem autoFocus={false}>
            {dictionary.header_file_label}
            {employeeInformation?.legajo}
          </MenuItem>
        ) : (
          <MenuItem autoFocus={false}>
            {dictionary.header_agent_label}
            {user?.displayName}
          </MenuItem>
        )}
        {agentInfo && agentInfo.documentNumber && (
          <MenuItem autoFocus={false}>
            {dictionary.header_agentCI_label}
            {agentInfo.documentNumber}
          </MenuItem>
        )}
        {showSelectEntityMenu && (
          <MenuItem
            onClick={handleEntityChanged}
            autoFocus={false}
            data-testid="change-entity-header-menu"
          >
            <PeopleIcon style={{ marginRight: '4px' }} />
            {dictionary.header_menu_changeEntity_seller}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default HeaderMenu;
